/* ==========================================================
   DIWALI DECOR — hero sparkle / firework (lightweight canvas)
   - Home page only, only inside the hero section
   - Pauses when hero is off-screen or tab is hidden
   - Skipped completely for prefers-reduced-motion
   Optional: add data-diwali-hero to your hero section wrapper
   to choose the exact element.
   ========================================================== */
(function () {
  'use strict';

  if (!document.documentElement.classList.contains('diwali-on')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var isHome =
    document.body.className.indexOf('template-index') > -1 ||
    /^\/([a-z]{2}(-[a-z]{2})?\/?)?$/i.test(location.pathname);
    if (!isHome) return;

  var PLAY_MS = 6000; // how long fireworks play (milliseconds)

  // play only once per session (first visit of the site)
  try { if (sessionStorage.getItem('dwHeroFx')) return; } catch (e) {}

  function init() {
    var hero =
      document.querySelector('[data-diwali-hero]') ||
      document.querySelector('#MainContent .shopify-section:first-child') ||
      document.querySelector('main .shopify-section:first-child');
    if (!hero) return;

    if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';

    var canvas = document.createElement('canvas');
    canvas.className = 'dw-sparkle-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    hero.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0;
    var isMobile = window.innerWidth < 768;
    var MAX = isMobile ? 120 : 280;
    var particles = [];
        var running = false, visible = true, raf = 0, nextBurst = 0, t0 = 0, done = false;

    var COLORS = [0, 25, 45, 120, 190, 220, 275, 320]; // red, orange, gold, green, cyan, blue, purple, pink

    function resize() {
      var r = hero.getBoundingClientRect();
      w = r.width; h = r.height;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function spawnRise() {
      particles.push({
        x: Math.random() * w,
        y: h + 6,
        vx: (Math.random() - 0.5) * 0.4,
        vy: -(0.35 + Math.random() * 0.7),
        g: 0,
        life: 0,
        max: 140 + Math.random() * 100,
        size: 0.8 + Math.random() * 1.6,
        hue: COLORS[(Math.random() * COLORS.length) | 0]
      });
    }

    function burst() {
      var cx = w * (0.1 + Math.random() * 0.8);
      var cy = h * (0.1 + Math.random() * 0.5);
      var hueA = COLORS[(Math.random() * COLORS.length) | 0];
      var hueB = COLORS[(Math.random() * COLORS.length) | 0];
      var n = isMobile ? 28 : 56;
      var power = 1.6 + Math.random() * 2.2;
      var ring = Math.random() < 0.4; // some bursts form a clean circle
      var i, a, s;

      for (i = 0; i < n; i++) {
        a = (Math.PI * 2 * i) / n + Math.random() * 0.15;
        s = ring ? power : power * (0.35 + Math.random() * 0.75);
        particles.push({
          x: cx, y: cy,
          vx: Math.cos(a) * s,
          vy: Math.sin(a) * s,
          g: 0.03,
          life: 0,
          max: 70 + Math.random() * 50,
          size: 1.4 + Math.random() * 1.8,
          hue: i % 2 ? hueA : hueB,
          l: 60,
          spark: Math.random() < 0.35
        });
      }

      // bright white-gold flash in the centre
      for (i = 0; i < (isMobile ? 5 : 10); i++) {
        a = Math.random() * Math.PI * 2;
        s = Math.random() * 0.8;
        particles.push({
          x: cx, y: cy,
          vx: Math.cos(a) * s,
          vy: Math.sin(a) * s,
          g: 0,
          life: 0,
          max: 18 + Math.random() * 12,
          size: 2.4 + Math.random() * 1.6,
          hue: 48,
          l: 88,
          spark: false
        });
      }
    }
    function finish() {
      done = true;
      running = false;
      cancelAnimationFrame(raf);
      if (canvas.parentNode) canvas.parentNode.removeChild(canvas);
    }

    function frame(t) {
      if (!running) return;
      if (!t0) t0 = t;
      var spawning = (t - t0) < PLAY_MS;

      // fade old frame = glowing trails
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,0.2)';
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';

      if (spawning) {
        if (particles.length < MAX && Math.random() < 0.12) spawnRise();

        if (t > nextBurst) {
          if (particles.length < MAX + 120) {
            burst();
            if (Math.random() < 0.45) setTimeout(function () { if (running) burst(); }, 180);
          }
          nextBurst = t + (isMobile ? 800 : 450) + Math.random() * 650;
        }
      } else if (!particles.length) {
        finish(); // time is over and all sparks have faded
        return;
      }

      for (var i = particles.length - 1; i >= 0; i--) {
        var p = particles[i];
        p.life++;
        p.vy += p.g;
        if (p.g) { p.vx *= 0.985; p.vy *= 0.985; }
        p.x += p.vx;
        p.y += p.vy;
        var k = 1 - p.life / p.max;
        if (k <= 0) { particles.splice(i, 1); continue; }
        var alpha = k * 0.95;
        if (p.spark && (p.life % 4 < 2)) alpha *= 0.35;
        ctx.beginPath();
        ctx.fillStyle = 'hsla(' + p.hue + ',100%,' + (p.l || 60) + '%,' + alpha.toFixed(3) + ')';
        ctx.arc(p.x, p.y, p.size, 0, 6.2832);
        ctx.fill();
      }
      raf = requestAnimationFrame(frame);
    }
    function start() {
      if (done || running || !visible || document.hidden) return;
      running = true;
      try { sessionStorage.setItem('dwHeroFx', '1'); } catch (e) {}
      raf = requestAnimationFrame(frame);
    }
    function stop() {
      running = false;
      cancelAnimationFrame(raf);
    }

    resize();
    window.addEventListener('resize', function () { isMobile = window.innerWidth < 768; resize(); }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        visible ? start() : stop();
      }, { threshold: 0.05 }).observe(hero);
    } else {
      start();
    }
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ==========================================================
   FOOTER sparkle — small, occasional bursts (much lighter than hero)
   ========================================================== */
(function () {
  'use strict';

  if (!document.documentElement.classList.contains('diwali-on')) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var foot = document.querySelector('footer.footer');
    if (!foot) return;
    if (getComputedStyle(foot).position === 'static') foot.style.position = 'relative';

    var canvas = document.createElement('canvas');
    canvas.className = 'dw-sparkle-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    foot.appendChild(canvas);

    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var w = 0, h = 0, particles = [];
    var isMobile = window.innerWidth < 768;
    var COLORS = [0, 25, 45, 120, 190, 220, 275, 320];
    var running = false, visible = false, raf = 0, nextBurst = 0;

    function resize() {
      var r = foot.getBoundingClientRect();
      w = r.width; h = r.height;
      canvas.width = Math.round(w * dpr);
      canvas.height = Math.round(h * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }

    function burst() {
      var cx = w * (0.12 + Math.random() * 0.76);
      var cy = h * (0.18 + Math.random() * 0.4);
      var hueA = COLORS[(Math.random() * COLORS.length) | 0];
      var hueB = COLORS[(Math.random() * COLORS.length) | 0];
      var n = isMobile ? 11 : 18;
      var power = 1.1 + Math.random() * 1.3;
      for (var i = 0; i < n; i++) {
        var a = (Math.PI * 2 * i) / n + Math.random() * 0.2;
        var s = power * (0.5 + Math.random() * 0.6);
        particles.push({
          x: cx, y: cy,
          vx: Math.cos(a) * s,
          vy: Math.sin(a) * s,
          life: 0,
          max: 45 + Math.random() * 30,
          size: 1 + Math.random() * 1.2,
          hue: i % 2 ? hueA : hueB
        });
      }
    }

    function frame(t) {
      if (!running) return;
      ctx.globalCompositeOperation = 'destination-out';
      ctx.fillStyle = 'rgba(0,0,0,0.22)';
      ctx.fillRect(0, 0, w, h);
      ctx.globalCompositeOperation = 'lighter';

      if (t > nextBurst) {
        if (particles.length < 60) burst();
        nextBurst = t + 2200 + Math.random() * 1800;
      }

      for (var i = particles.length - 1; i >= 0; i--) {
        var p = particles[i];
        p.life++;
        p.vy += 0.03;
        p.vx *= 0.985; p.vy *= 0.985;
        p.x += p.vx; p.y += p.vy;
        var k = 1 - p.life / p.max;
        if (k <= 0) { particles.splice(i, 1); continue; }
        ctx.beginPath();
        ctx.fillStyle = 'hsla(' + p.hue + ',100%,62%,' + (k * 0.9).toFixed(3) + ')';
        ctx.arc(p.x, p.y, p.size, 0, 6.2832);
        ctx.fill();
      }
      raf = requestAnimationFrame(frame);
    }

    function start() {
      if (running || !visible || document.hidden) return;
      running = true;
      raf = requestAnimationFrame(frame);
    }
    function stop() {
      running = false;
      cancelAnimationFrame(raf);
      ctx.clearRect(0, 0, w, h);
      particles.length = 0;
    }

    resize();
    window.addEventListener('resize', function () { isMobile = window.innerWidth < 768; resize(); }, { passive: true });
    document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        visible = entries[0].isIntersecting;
        visible ? start() : stop();
      }, { threshold: 0.05 }).observe(foot);
    } else {
      visible = true;
      start();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();